          <template>
    <v-card class="transparent stickytopconscious" width="100%" height="100%">
    <!-- <v-card class="transparent"> -->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
            <v-parallax
            height="150"
            src="@/assets/Parallax_Logo.jpeg"
            >
              
              <v-row
              align="center"
              justify="center"
            >
              <v-col class="parallaxbgcontentgrad text-center" cols="12">
                <h1 class="display-2 font-weight-thin mb-4">Financial</h1>
                <h4 class="headline">FREEDOM</h4>
              </v-col>
            </v-row>
            </v-parallax>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card color="#FFFFFF" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                    <h2 class="primary--text mx-1 my-3" align="center">Debt Counselling</h2>          
                <p class="MsoNormal">It is a process based on the New Credit Act, where a
registered debt counsellors acts on your behalf. It is the recommended process
to follow, if your main priority is to retain property or vehicle(s) under
finance.</p>

<p class="MsoNormal">A debt counsellor enters renegotiation with your creditors,
reducing your instalments in accordance with your affordability.</p>

<p class="MsoNormal">Interest rates and contract periods are also renegotiated,
as you still have to settle the full capital amounts outstanding plus interest,
before the process may be concluded.<o:p></o:p></p>

<p class="MsoNormal"><o:p>&nbsp;</o:p></p>

<p class="MsoNormal">Once agreements was reached between your creditors and debt
counsellor, it may go to court for court order to be issued. It is not a process that prohibits creditors from taking
legal action, should the process be terminated for whatever reason.&nbsp;</p><p class="MsoNormal"><br></p><p class="MsoNormal">There is no specific time frame of how long the process
might take, as it is based on the consumer's income, expenditures and total
debt outstanding.&nbsp;</p>

<p class="MsoNormal">Once it all accounts were settled, your debt counsellor may
then issue a clearance certificate in order to restore your name on credit
bureaus.</p>

<p class="MsoNormal">The aim of debt counselling is to find ways in your budget
for you to pay off your debts while still having enough income to cover all your basic living expenses such as groceries,
rent, fuel, school fees and electricity.&nbsp;</p>

<p class="MsoNormal">By analysing your finances, your debt counsellor will assess
and identify your debt problem areas and devise solutions to free up disposable income in order to pay off your debts.&nbsp;</p>

<p class="MsoNormal"><u>Benefits of Debt Review:</u><o:p></o:p></p>

<p class="MsoNormal"><o:p>&nbsp;</o:p></p>

<p class="MsoNormal"></p><ul><li>Debt counsellor intercedes on your behalf, thus handling all
correspondence and negotiations between yourself and your creditors on your
behalf.</li><li>Assets under hire purchase will remain in your possession</li><li>Instalments decreased in accordance with your affordability</li><li>Proposed agreements will go through Magistrate's court for
court order</li><li>Creditors and Debt counsellor needs to comply with New Credit
Act (NCA)</li></ul><o:p></o:p><p></p>

<p class="MsoNormal"><o:p></o:p></p>

<p class="MsoNormal"><o:p></o:p></p>

<p class="MsoNormal"><o:p></o:p></p>



<p class="MsoNormal"><o:p>&nbsp;</o:p></p>

<p class="MsoNormal">For more information, contact us, or submit an application<o:p></o:p></p><br><br><br>
                </v-flex>
                </v-layout>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
        <v-img src="@/assets/Helping_Hand.jpeg"  width="100%" height="300">
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                </v-flex>
                </v-layout>
        </v-img>            
            </v-card>
            <!-- </div>-->
            
        </v-card> 
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'


export default {
  
name: 'DebtCounselling',
metaInfo: {
    title: 'DebtCounselling Service - Tribunes SA',
    meta: [
      {
        name: 'description',
        content: `Navigate debt with the help of registered debt counsellors. Retain assets while renegotiating payments with creditors. Find tailored solutions for financial freedom. Contact us to start.`
      },
      {
        name: 'keywords',
        content: 'DebtCounselling, Insolvency, Tribunes SA'
      }
    ]
  },
    components: {
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
    }
    },
    computed:{
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,210, 1));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        